import { Skeleton } from '@mantine/core';
import { FC } from 'react';

interface PrimaryNavIconsSkeletonProps {
  count?: number;
}

const PrimaryNavIconsSkeleton: FC<PrimaryNavIconsSkeletonProps> = ({ count = 1 }) => (
  <>
    {Array.from({ length: count }, (_, index) => (
      <Skeleton key={`primary-nav-icon-skeleton-${index}`} height={40} width={40} radius={10} />
    ))}
  </>
);

export default PrimaryNavIconsSkeleton;
